import { useClearHistory } from '@/api/hooks'
import { Button, Dialog, toast } from '@/components/ui'

/** Confirming the one destructive thing you can do to your listening history.
 *  Shared by the settings card and the full page, so the wording is the same
 *  wherever you happen to press it. */
export function ClearHistoryDialog({ onClose }: { onClose: () => void }) {
  const clear = useClearHistory()

  function confirm() {
    clear.mutate(undefined, {
      onSuccess: (result) => {
        onClose()
        toast.success(
          'History cleared',
          result.deleted > 0
            ? `Deleted ${result.deleted} ${result.deleted === 1 ? 'entry' : 'entries'}. Your library and play counts are unchanged.`
            : 'There was nothing to delete.',
        )
      },
      onError: () =>
        toast.error('Could not clear your history', 'Nothing was deleted — try again.'),
    })
  }

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open && !clear.isPending) onClose()
      }}
      size="sm"
      title="Clear listening history"
      description="Every entry is deleted, not just the ones shown here. This cannot be undone."
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={clear.isPending}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirm} loading={clear.isPending}>
            Clear history
          </Button>
        </>
      }
    >
      <p className="text-sm text-text-muted">
        Your library, favourites and play counts are not affected. Tunes will start recording
        again from your next play.
      </p>
    </Dialog>
  )
}
